import CardServico from './cardServicos'
import Container from './container'

export function ModeloEntrega() {
  const modelos = [
    {
      id: 1,
      icon: '../assets/icones/icone-pessoas.png',
      iconHover: '../assets/icone-pessoas.png',
      title: 'SQUADS',
      text: (
        <>
          <strong>Cada negócio é único — e sua equipe também deve ser.</strong>{' '}
          Por isso, formamos equipes multidisciplinares sob medida, pensadas
          especialmente para entender e atender às necessidades específicas da
          sua empresa, com dedicação, expertise e propósito.
        </>
      ),
      glowColor: '#D700E2',
      url: '/squad',
      textoBotao: 'Saiba mais',
      widthFull: true,
    },
    {
      id: 2,
      icon: '../assets/icones/icone-grid.png',
      iconHover: '../assets/icones/icone-grid.png',
      title: 'SMARTSOURCING',
      text: (
        <>
          Nos nossos serviços de smartsourcing, você conta com a alocação de
          profissionais altamente capacitados que oferecem rapidez e precisão na
          entrega de cada projeto.
        </>
      ),
      glowColor: '#D700E2',
      url: '/smartsourcing',
      textoBotao: 'Saiba mais',
      widthFull: true,
      heightFull: true,
    },
    {
      id: 3,
      icon: '../assets/icones/icone-planilha.png',
      iconHover: '../assets/icones/icone-planilha.png',
      title: 'Escopo Fechado',
      text: (
        <>
          Oferecemos um modelo de entrega de escopo fechado, garantindo
          previsibilidade, controle e resultados de alta qualidade para nossos
          clientes.
        </>
      ),
      glowColor: '#D700E2',
      url: '/escopo-fechado',
      textoBotao: 'Saiba mais',
      widthFull: true,
    },
  ]

  const lista = [
    {
      id: 1,
      label: 'Equipes Especializadas',
    },
    {
      id: 2,
      label: 'Compromisso com a Entrega',
    },
    {
      id: 3,
      label: 'Abordagem Ágil',
    },
  ]

  return (
    <section className="bg-[#130B45] bg-[url(../assets/banner-modelo.png)] bg-no-repeat bg-cover bg-bottom text-white">
      <Container className="pt-18 md:pt-28 pb-40 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h2 className="text-[37px] md:text-6xl mb-4 leading-[1.2] md:leading-[1] text-center md:text-left">
            Modelos <br />
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              de Entrega
            </span>
          </h2>
          <p className="mb-6 text-xl md:text-2xl pr-2 text-center md:text-left pt-4 md:pt-0">
            Desenvolvemos projetos com modelos de entrega flexíveis e
            eficientes, adaptados às necessidades dos seus negócios.
          </p>
          <div className="flex justify-center md:justify-start py-4 md:py-0 mb-4">
            <div className="space-y-4 flex flex-col items-start">
              {lista.map(item => (
                <div className="flex items-center gap-4 md:gap-3" key={item.id}>
                  <img src="../assets/icones/icone-checkbox-branco.png" alt="" />
                  <span className="font-inter-bold text-base">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        {modelos.map(modelo => (
          <div key={modelo.id}>
            <CardServico
              {...modelo}
              saberMais
              className="h-full md:h-[380px] w-full md:w-auto"
            />
          </div>
        ))}
      </Container>
    </section>
  )
}
